import { useEffect, useState } from 'react';
import { AuthLayout } from '../../layout';
import { CheckEmail } from '../../features/reset';
import { PAGES_ANALYTICS_TITLES } from '../../utils/enums';
import { PageHelmet } from '../../components';
import { AuthBackgroundLayout } from '../../layout/auth/AuthBackgroundLayout';

const CheckEmailPage = () => {
  const [isEmbedded, setIsEmbedded] = useState(true);

  useEffect(() => {
    setIsEmbedded(window !== window.parent);
  }, []);

  if (isEmbedded) {
    return (
      <AuthBackgroundLayout>
        <CheckEmail />
      </AuthBackgroundLayout>
    );
  }

  return (
    <PageHelmet title={PAGES_ANALYTICS_TITLES.CHECK_EMAIL}>
      <AuthLayout>
        <CheckEmail />
      </AuthLayout>
    </PageHelmet>
  );
};

export default CheckEmailPage;
